import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Element from 'element-ui'
import './pollyfills'
import VueRouter from 'vue-router'
import VueNotify from 'vue-notifyjs'
import VeeValidate from 'vee-validate'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import App from './App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueSession from 'vue-session'
import VueCookie from 'vue-cookie'


// Plugins
import GlobalComponents from './gloablComponents'
import GlobalDirectives from './globalDirectives'
import SideBar from './components/UIComponents/SidebarPlugin'

// router setup
import routes from './routes/routes'

// mixins
import InmobitoMx from 'src/mixins/Inmobito'

// store
import store from './store/index'

// library imports
import './assets/sass/paper-dashboard.scss'
import './assets/sass/element_variables.scss'
import './assets/sass/demo.scss'

import sidebarLinks from './sidebarLinks'

import moment from 'moment'

// translates
import messages from './lang/lang'

// Wysiwyg editor
import wysiwyg from 'vue-wysiwyg'

// plugin setup
Vue.use(VueI18n)
Vue.use(VueRouter)
Vue.use(GlobalDirectives)
Vue.use(GlobalComponents)
Vue.use(VueNotify)
Vue.use(SideBar, {sidebarLinks: sidebarLinks})
Vue.use(VeeValidate)
Vue.use(VueAxios, axios)
locale.use(lang)
Vue.use(wysiwyg, {
  hideModules: { 'image': true, 'code': true, 'table': true },
  maxHeight: '500px'
})
Vue.use(VueSession, {persist: 1})
Vue.use(VueCookie)

Vue.mixin(InmobitoMx)

// --------------------------------------------------------------------
// configure router
// --------------------------------------------------------------------
// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: 'en', // set locale
  fallbackLocale: 'en', // if the message does not exists show the english version
  messages // set locale messages
})

locale.i18n((key, value) => i18n.t(key, value))

const router = new VueRouter({
  i18n,
  routes, // short for routes: routes
  linkActiveClass: 'active'
})

// --------------------------------------------------------------------
// filters
// --------------------------------------------------------------------
Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})
Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY')
  }
})
Vue.filter('formatDateTime', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY H:mm')
  }
})
Vue.filter('formatTime', function (value) {
  if (value) {
    return moment(String(value)).format('H:mm')
  }
})

// --------------------------------------------------------------------
/* eslint-disable no-new */
// --------------------------------------------------------------------
new Vue({
  el: '#app',
  render: h => h(App),
  i18n,
  router,
  store
})




// WEBPACK FOOTER //
// ./src/main.js